import { Routes } from '@angular/router';
import { SuccessRouteGuard } from '@app-core';
import { ErrorComponent, NotFoundComponent, PrivacyPolicyComponent, TermsConditionsComponent } from '@app-shared';
import { ClaimResolverEmployer } from './core/guards/claim-resolver-employer';
import { ClaimResolverParent } from './core/guards/claim-resolver-parent';
import { ClaimResolverPhysician } from './core/guards/claim-resolver-physician';
import { EmployerResponseComponent } from './employer-response/employer-response.component';
import { FraudNoticesComponent } from './fraud-notices/fraud-notices.component';
import { NotActionableComponent } from './not-actionable/not-actionable.component';
import { ParentResponseComponent } from './parent-response/parent-response.component';
import { PhysicianResponseComponent } from './physician-response/physician-response.component';
import { SubmissionComponent } from './submission/submission.component';
import { SuccessResponseEmployerComponent } from './success-response-employer/success-response-employer.component';
import { SuccessResponseMedicalComponent } from './success-response-medical/success-response-medical.component';
import { SuccessResponseComponent } from './success-response/success-response.component';
import { UploadCompleteComponent } from './upload-complete/upload-complete.component';
import { UploadDocumentEmployerComponent } from './upload-document-employer/upload-document-employer.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';

export const ROUTES: Routes = [
    {
        path: 'parent-response',
        component: ParentResponseComponent,
        resolve: { claim: ClaimResolverParent },
    },
    {
        path: 'physician-response',
        component: PhysicianResponseComponent,
        resolve: { claim: ClaimResolverPhysician },
    },
    {
        path: 'employer-response',
        component: EmployerResponseComponent,
        resolve: { claim: ClaimResolverEmployer },
    },

    { path: 'upload-document', component: UploadDocumentComponent },
    { path: 'upload-document-employer', component: UploadDocumentEmployerComponent },
    { path: 'upload-complete', component: UploadCompleteComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    { path: 'terms-conditions', component: TermsConditionsComponent },
    { path: 'not-actionable', component: NotActionableComponent },
    { path: 'submission', component: SubmissionComponent },
    { path: 'success', component: SuccessResponseComponent, canActivate: [SuccessRouteGuard] },
    { path: 'success-medical', component: SuccessResponseMedicalComponent, canActivate: [SuccessRouteGuard] },
    { path: 'success-employer', component: SuccessResponseEmployerComponent, canActivate: [SuccessRouteGuard] },

    { path: 'fraud-notices', component: FraudNoticesComponent },
    { path: 'error', component: ErrorComponent },
    { path: 'not-found', component: NotFoundComponent },
    { path: '', redirectTo: 'parent-response', pathMatch: 'full' },
    { path: '**', component: NotFoundComponent },
];
